import { lazy, Suspense, forwardRef } from 'react';

const LazyAIAgent = lazy(
  () =>
    import(
      /* webpackChunkName: "aiAgentV2" */
      /* webpackPrefetch: true */
      './AIAgent'
    ),
);

export default forwardRef(function AIAgentV2(props, ref) {
  return (
    <Suspense fallback={null}>
      <LazyAIAgent {...props} ref={ref} />
    </Suspense>
  );
});
